import * as React from "react";
import type { GitRefQueryParamsProps } from "../../BranchSelector/useProjectGitRef";
import type { RunGoal } from "../RunbookRunNowLayout";
import { RunbookRunNowLayout } from "../RunbookRunNowLayout";
interface RunRunbookPageProps extends GitRefQueryParamsProps {
    goal: RunGoal;
    runbookSnapshotId: string;
}
export function RunRunbookPage({ goal, runbookSnapshotId, queryParams, setQueryParams }: RunRunbookPageProps) {
    return (<>
            <RunbookRunNowLayout runbookSnapshotId={runbookSnapshotId} goal={goal} queryParams={queryParams} setQueryParams={setQueryParams}/>
        </>);
}
